
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/contexts/AuthContext";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { LoginForm } from "@/components/auth/LoginForm";
import { RegisterForm } from "@/components/auth/RegisterForm";

const Login = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const { user, associateGameWithUser, signInWithGoogle } = useAuth();

  useEffect(() => {
    if (user) {
      const checkPendingGame = async () => {
        const pendingGameId = localStorage.getItem('pendingGameToAssociate');
        if (pendingGameId) {
          const success = await associateGameWithUser(pendingGameId);
          if (success) {
            toast({
              title: "Game saved!",
              description: "Your game has been associated with your account.",
            });
          }
          localStorage.removeItem('pendingGameToAssociate');
        }
        
        navigate('/');
      };
      
      checkPendingGame();
    }
  }, [user, associateGameWithUser, navigate, toast]);

  const handleGoogleSignIn = async () => {
    try {
      setIsLoading(true);
      await signInWithGoogle();
    } catch (error: any) {
      console.error("Google sign-in error:", error);
      toast({
        variant: "destructive",
        title: "Sign in failed",
        description: error.message || "Failed to sign in with Google. Please try again."
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout>
      <Tabs defaultValue="login" className="w-full mb-6">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger id="login-tab" value="login">Login</TabsTrigger>
          <TabsTrigger value="register">Register</TabsTrigger>
        </TabsList>
        
        <Card className="border-border mt-6">
          <CardContent className="p-6">
            <TabsContent value="login" className="pt-0 pb-0 mt-0">
              <LoginForm 
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                onGoogleSignIn={handleGoogleSignIn}
              />
            </TabsContent>
            
            <TabsContent value="register" className="pt-0 pb-0 mt-0">
              <RegisterForm 
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                onGoogleSignIn={handleGoogleSignIn}
              />
            </TabsContent>
          </CardContent>
        </Card>
      </Tabs>
    </AuthLayout>
  );
};

export default Login;
